export default __webpack_public_path__ + "static/media/cli-alph-resi_real2.c4a507a2.jpg";